import React, {useState} from 'react';
import {MainLayout} from 'app/components/MainLayout';
import {EmailFormResetPass} from 'app/components/emailForm/EmailFormResetPass';
import styled from 'styled-components';
import {Info} from 'app/styles/InfoText';
import {Emph, Secondary, StyledButton} from 'app/styles/content';
import {LinkOnComponent} from 'app/styles/link';
import {Helmet} from 'react-helmet-async';
import {ErrorAlert} from 'app/components/error/ErrorAlert';
import {LoadingOverlay} from 'app/components/loading/LoadingOverlay';

const CustomInfo = styled(Info)`
  &&& {
    margin-top: 0;
    text-align: left;
  }
`;

const ResetPasswordPage = () => {
  const [isSending, setIsSending] = useState(false);
  const [emailSent, setEmailSent] = useState(false);
  const [error, setError] = useState(null);
  const [emailWithError, setEmailWithError] = useState('');
  const meta = [
    {name: 'description', content: 'Du hast dein FuPa-Passwort vergessen? Hier kannst du es zurücksetzen.'},
  ];
  const handleLoading = (value) => {
    setIsSending(value);
  };

  const handleError = (error, email) => {
    setError(error);
    setEmailWithError(email);
  };

  const handleEmailSent = (value) => {
    setEmailSent(value);
  };

  let title = 'Passwort zurücksetzen';
  // Independent of the connected AuthProvider(s), firebase transforms the account to EmailAndPassword-only
  let content = (
    <>
      <CustomInfo variant='body1'>
        Wir senden dir einen Link mit dem du dein Passwort zurücksetzen kannst. Sobald du den Link anforderst, werden
        mit deinem Konto verknüpfte Social Logins ebenfalls aufgehoben.
      </CustomInfo>
      <EmailFormResetPass
        setIsSending={(value) => handleLoading(value)}
        onError={(error, email) => handleError(error, email)}
        onSuccess={(value) => handleEmailSent(value)}
      />
    </>
  );

  if (emailSent) {
    title = 'Überprüfe dein E-Mail-Postfach';
    content = (
      <>
        <CustomInfo variant='body1'>
          Wir haben eine Nachricht an <Emph variant='body-strong'>{emailSent}</Emph> gesendet.
          <br /> Mit dem darin enthaltenen Link kannst du ein neues Passwort festlegen.
        </CustomInfo>
        <CustomInfo variant='body1'>
          Du hast keine E-Mail erhalten, auch nicht in deinem Spam-Ordner?{' '}
          <Secondary tabIndex='0' onClick={() => setEmailSent(null)}>
            Erneut versuchen
          </Secondary>
        </CustomInfo>
        <LinkOnComponent tabIndex='-1' to='/auth/login'>
          <StyledButton justify='center' label='Zurück zum Anmelden' />
        </LinkOnComponent>
      </>
    );
  }

  const showError = error ? <ErrorAlert error={error} email={emailWithError} /> : null;

  return (
    <>
      <LoadingOverlay open={isSending} />
      <Helmet title='Passwort vergessen / zurücksetzen' meta={meta}>
        <link rel='canonical' href='https://www.fupa.net/auth/reset-password' />
      </Helmet>
      <MainLayout title={title}>
        {content}
        {showError}
      </MainLayout>
    </>
  );
};

export default ResetPasswordPage;
